export const generateId = (): string => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
};

export const formatDate = (date: Date): string => {
  return date.toISOString().split("T")[0];
};

// Formats as YYYY-MM-DD in the user's local timezone (avoids UTC shift)
export const formatDateLocal = (date: Date): string => {
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
};

export const isTodayOrTomorrow = (date: Date): boolean => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const dateStr = formatDate(date);
  const todayStr = formatDate(today);
  const tomorrowStr = formatDate(tomorrow);

  return dateStr === todayStr || dateStr === tomorrowStr;
};

export const getDaysBetween = (date1: Date, date2: Date): number => {
  const timeDiff = Math.abs(date2.getTime() - date1.getTime());
  return Math.ceil(timeDiff / (1000 * 3600 * 24));
};

const DEFAULT_RANGE_LOCALE = "en-GB";

export const formatDisplayDate = (
  date: Date,
  locale: string = DEFAULT_RANGE_LOCALE,
): string => {
  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
};

export const formatDisplayDateRange = (
  start: Date,
  end: Date,
  locale: string = DEFAULT_RANGE_LOCALE,
): string => {
  return `${formatDisplayDate(start, locale)} to ${formatDisplayDate(
    end,
    locale,
  )}`;
};
